/***
 * Created on 2025/2/6
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useState} from 'react';
import {useOnChange, useLanguage} from 'common/Hook';
import {useTranslation} from "react-i18next";
import Captcha from "../common/captcha";
import ic_sys_info from '../../static/img/utils/ic-sys-info.svg';
import {Tooltip} from "react-tooltip";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiPost} from "../../service/api";

function IftttDeviceLogin({state, dispatch}) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const [visiblePasswd, setVisiblePasswd] = useState(false);
    const [require2FA, setRequire2FA] = useState(false);
    const [isLoginFailed, setIsLoginFailed] = useState(false);
    const [counter, setCounter] = useState(0);
    const clientQuery = useQueryClient()
    const {onChange, values, setValues} = useOnChange({
        package_ids: state.device.package_ids,
        app_id: state.device.app_id,
        user_id: state.device.user_id,
        device_id: state.device.device_id,
        device_user: '',
        password: '',
        captcha: ''
    });

    const togglePassword = () => {
        setVisiblePasswd(prev => !prev);
    }

    const deviceLoginMutate = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/dauth/authorization', data),
        onSuccess: async (data) => {
            await queryClient.invalidateQueries('dauth_authorization_statue');
            dispatch({type: 'toggleDeviceList', payload: true});
        },
        onError: (error) => {
            clientQuery.invalidateQueries('get_captcha_image');
            if (error?.cause?.code === 1129006) {
                setRequire2FA(true);
                setCounter(prev => prev + 1);
            }
            else if (error?.cause?.code === 1129005) {
                setIsLoginFailed(true);
            }
        }
    });

    const deviceLogin = async () => {
        setIsLoginFailed(false);
        await deviceLoginMutate.mutateAsync(values);
    }

    return (
        <div className="ifttt--login">
            <div className="ifttt--login__subtitle">{t('@Login your device to grant access to IFTTT:@')}</div>
            <div className="common-info-grid common-info-grid--sign-in">
                <div className="ifttt--login__subtitle mt-16 !mb-24">{state?.device?.device_name}</div>
                <div className="common-form-group">

                    <p className={`text-error ${isLoginFailed ? '' : 'hide'}`}>{t('@Login failed.@')}</p>

                    <div className="comp-input !mb-24">
                        <div className="input-field--modern">
                            <input type="text" className="input--modern" inputMode={"text"}
                                   placeholder={t('@User name@')} name="device_user" value={values.device_user}
                                   onChange={onChange}/>
                            <label className="input-label--modern">{t('@User name@')}</label>
                        </div>
                    </div>

                    {/*// <!-- 密碼輸入框 -->*/}
                    <div className="comp-input">
                        <div className="input-field--modern">
                            <div className="input-field--pwd">
                                        <span className={`input-toggle--pwd ic-eye-${visiblePasswd ? 'open' : 'close'}`}
                                              onClick={togglePassword}></span>
                                <input type={visiblePasswd ? 'text' : 'password'} className="input--modern"
                                       placeholder={t('@Password@')} name="password" value={values.password}
                                       onChange={onChange}/>
                                <label className="input-label--modern">{t('@Password@')}</label>
                            </div>
                        </div>
                    </div>
                </div>

                {require2FA &&
                    <div className="common-form-group">
                        <p>{t('@Enter the code generated by your authenticator app.@')}</p>
                        <div className="comp-input">
                            <div className="input-field--hybrid">
                                <input
                                    onChange={onChange}
                                    value={values?.security_code}
                                    type="text"
                                    className={`${counter > 1 ? "input--invalid" : ""} input--must-fill`}
                                    name="security_code"/>
                            </div>
                        </div>
                        {counter > 1 && <p className="text-error mt-10 ">{t('@The code you entered is incorrect.@')}</p>}
                        {/*<a href="#" className="mt-10">Can't use authenticator app?</a>*/}
                    </div>
                }

                <Captcha value={values.captcha} inputChangeHandler={onChange}
                         resetValue={() => setValues(prev => ({...prev, captcha: ''}))}/>

                <button className="q-btn q-btn--primary btn-medium btn-rounded-normal w-full" data-btn-signin="regular" onClick={deviceLogin}>{t('@Allow@')}</button>

                <p className="!mt-32 !mb-24">
                    <span>
                        {t('@Note: The {app_name} QPKG will install or update, then enable automatically on your device.@', {
                            app_name: 'IFTTT',
                            interpolation: {
                                prefix: '{',
                                suffix: '}',
                                escapeValue: false
                            }
                        })}
                        &nbsp;
                    </span>
                    <img src={ic_sys_info}
                         data-tooltip-id="dauth-login-info"
                         data-tooltip-content={t('@{app_name} QPKG is required before you create any recipes. Once the QPKG is installed and enabled, you can start creating recipes directly on IFTTT.@', {
                             app_name: 'IFTTT',
                             interpolation: {
                                 prefix: '{',
                                 suffix: '}',
                                 escapeValue: false
                             }
                         })}
                         className="display-inline-block vertical-align-middle w-18px h-18px"/>
                </p>
            </div>

            <div className="mt-16"><a href="#">{t('@Sign in with a different account@')}</a></div>

            <Tooltip id="dauth-login-info"/>
        </div>
    );
}

export default IftttDeviceLogin;